module.exports = __webpack_public_path__ + "img/p1.07495697.png";